/*  ==========================================================================
    OFFERS LIST VIEW
    ========================================================================== */

/*
 * IMPORTS
 */

// node modules imports
import $ from 'jquery';
import 'jquery-inview';

// local imports
import * as vars from '../../globals/variables';
import * as utils from '../../utilities/utils';
import {slick_nextArrow, slick_nextArrowV2, slick_prevArrow, slick_prevArrowV2} from "../../globals/variables";

/*
 * MODULE
 */

// hook function
function funcHook(container,data) {

    // calculate min price and add it to record
    utils.ehotelierPrices.initEhotelierOfferMinPrice(data);

}

// custom function
function funcCustom(container,data) {

    // check if pagination is needed
    let $pagination = $(container).find('.bn-pagination');
    if (!$(container).hasClass('bn-offers-list-view__holder--slidable')) {
        if ($(container).hasClass('bn-offers-list-view__holder--paginated')) {
            if ($(container).attr('data-limit')) {
                let loadedItems = $(container).find('.bn-offer-box').length,
                    totalItems = data.total;
                if (loadedItems < totalItems) {
                    $pagination.removeClass('hidden');
                }
            } else {
                $pagination.remove();
            }
        } else {
            $pagination.remove();
        }
    } else {
        $pagination.remove();
    }

    // initialize slider
    if ($(container).hasClass('bn-offers-list-view__holder--slidable')) {
        let $sliderContainer = $(container),
            sliderOverrides = {
                dots: true,
                appendDots: $(container).parent().find('.bn-offers-list-view__dots'),
                equalHeight: true,
                nextArrow: vars.slick_nextArrowV2,
                pauseOnHover: true,
                prevArrow: vars.slick_prevArrowV2,
                autoplay: false,
                responsive: [
                    {
                        breakpoint: 769,
                        settings: {
                            equalHeight: false,
                            slidesToShow: 1
                        }
                    },
                ],
                slidesToShow: 1
            };

        // if container is enlarged change "slidesToShow" and responsive behaviour
        if ($(container).hasClass('bn-offers-list-view__holder--enlarged')) {
            sliderOverrides.responsive = [
                {
                    breakpoint: 1025,
                    settings: {
                        slidesToShow: 1
                    }
                },
            ];
            sliderOverrides.slidesToShow = 1;
        }

        utils.slickCarousel.initSingleSlider($sliderContainer,sliderOverrides);
    }

    if($(container).parent().find('.bn-offers-filter input:checkbox:checked').length === 0) {
        $(container).parent().find('.bn-offers-filter .bn-offers-filter__option--all input').prop('checked', true);
    }

    $(container).parent().find('.bn-offers-filter input').not('.bn-offers-filter__cat--all').change(function() {
        $(container).parent().find('.bn-offers-filter .bn-offers-filter__option--all input').prop('checked', false);
        $(container).attr("data-category", $(container).attr("data-category").replace("*,", ""));
    });

    $(container).parent().find('.bn-offers-filter input.bn-offers-filter__cat--all').change(function() {
        $(container).parent().find('.bn-offers-filter input').not('.bn-offers-filter__cat--all').prop('checked', false);
        $(container).attr("data-category","*");
    });

    // add param skd-search-id to booking link
    $(container).find('.JS-booking-button').each(function (event) {
        const $button = $(this),
            referrerData = window.BN.getMarketingSources();

        let oldUrl = $button.attr('href');
        if (!oldUrl.includes('skd-search-id')) {
            let newUrl = oldUrl + '&skd-search-id=' + referrerData.partner;
            $button.attr('href', newUrl);
        }
    });
}

// initialization
export function initOffersListView($element) {
    let container = $element.find('.eh-service'),
        page = 1;

    // config
    let config = {
        addParams: {
            page: page
        },
        container: container,
        funcCustom: funcCustom,
        funcHook: funcHook,
        type: 'offer',
        subtype: 'list-view'
    };

    // set a limit
    if ($(container).attr('data-limit')) {
        let limit = $(container).attr('data-limit');
        config.addParams.limit = limit;
    }

    // set category/ies
    if ($(container).attr('data-category')) {
        let category = $(container).attr('data-category');
        config.addParams.offercategories = category;
    }

    // filter
    if ($element.find('.bn-offers-filter')) {
        utils.ehotelierOfferFilter.initEhotelierOfferFilter($element,container,page,config);
    }

    // ehotelier service initialization (if element is in view)
    $element.one('inview', function() {
        utils.ehotelierLoader.initEhotlierService(config);
    });

    // pagination
    $(container).on('click', '.bn-pagination .bn-button', function () {
        page++;
        config.addParams.page = page;
        utils.ehotelierLoader.initEhotlierService(config);
        $(this).remove();
    });

    // details as pop up
    utils.ehotelierPopUp.initEhotelierPopUp(container,config);

}


// WEBPACK FOOTER //
// ./source/js/modules/lib/offers-list-view.js